export default {
    setEducations: 'SET_EDUCATIONS',
    setProfileDescription: 'SET_PROFILE_DESCRIPTION',
    setPhoto: 'SET_PHOTO',
    setLinkedinResume: 'SET_LINKEDIN_RESUME',
    setSeniority: 'SET_SENIORITY',
    setReasons: 'SET_REASONS',
    setProfileDescriptionRule: 'SET_PROFILE_DESCRIPTION_RULE',
    setExperiences: 'SET_EXPERIENCES',
    setActivityAreas: 'SET_ACTIVITY_AREAS',
    setRecommendations: 'SET_RECOMMENDATIONS',
    setHasLoadedAllData: 'SET_HAS_LOADED_ALL_DATA',
    setLoading: 'SET_LOADING',
    setCurrentStep: 'SET_CURRENT_STEP',
};
